import { useState } from 'react';
import { Modal, ModalCloseButton } from 'components/Shared';
import * as S from './styles';

interface Props {
  isCreating: boolean;
  onCancel: () => void;
  onCreate: (name: string) => void;
}

// Pede o nome antes de criar: o rastreio só nasce quando a pessoa confirma.
export const NewTrackingRouteDialog: React.FC<Props> = ({
  isCreating,
  onCancel,
  onCreate,
}) => {
  const [name, setName] = useState('');
  const trimmedName = name.trim();

  return (
    <Modal isOpen onClickOutside={isCreating ? undefined : onCancel}>
      <S.WarehouseDialog
        role="dialog"
        aria-modal="true"
        aria-label="Novo rastreio"
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (trimmedName && !isCreating) onCreate(trimmedName);
          }}
        >
          <header className="flex items-center justify-between gap-3 border-b border-slate-200 px-5 py-4">
            <h3 className="font-bold text-slate-800">Novo rastreio</h3>
            <ModalCloseButton onClick={onCancel} />
          </header>
          <div className="flex flex-col gap-2 px-5 py-4">
            <label className="flex flex-col gap-1 text-sm font-semibold text-slate-700">
              Nome do rastreio
              <S.NameInput
                autoFocus
                maxLength={120}
                placeholder="Ex.: Rota Paulínia"
                value={name}
                onChange={(event) => setName(event.target.value)}
                $invalid={false}
              />
            </label>
            <p className="text-xs text-slate-500">
              O rastreio nasce como rascunho. Depois, marque o centro no mapa e
              vincule os armazéns.
            </p>
          </div>
          <footer className="flex justify-end gap-2 border-t border-slate-200 px-5 py-4">
            <S.SecondaryButton
              type="button"
              disabled={isCreating}
              onClick={onCancel}
            >
              Cancelar
            </S.SecondaryButton>
            <S.PrimaryButton
              type="submit"
              disabled={!trimmedName || isCreating}
            >
              {isCreating ? 'Criando...' : 'Criar rastreio'}
            </S.PrimaryButton>
          </footer>
        </form>
      </S.WarehouseDialog>
    </Modal>
  );
};
